import React, { FC, PropsWithChildren, ReactElement } from "react"
import { NavLink } from "react-router-dom"

import { TablerIconsProps } from "@tabler/icons-react"
import TransparentButton, { TransparentButtonProps } from "../../inputs/transparent-button/TransparentButton"

type NavigationButtonProps = TransparentButtonProps & {
    target: string
    icon: (props: TablerIconsProps) => ReactElement
    variant?: TransparentButtonProps["variant"]
}

const NavigationButton: FC<PropsWithChildren<NavigationButtonProps>> = ({ children, target, icon: Icon, ...props }) => {
    return (
        <NavLink to={target}>
            <TransparentButton leftIcon={<Icon size={26} stroke={1.5} />} h="3rem" {...props}>
                {children}
            </TransparentButton>
        </NavLink>
    )
}

export default NavigationButton
